/**
 * Build-time cache of HtmlDocument payloads for prerendering.
 * Regenerate with: npm run generate-alias-cache
 */
export const aliasCache = {
  "pitchplanet-": {
    "urlRouteByAlias": {
      "hasErrors": false,
      "errors": null,
      "node": {
        "id": "f15aXXzOsGEqVJ8YSmlDXsw",
        "panels": [
          {
            "component": {
              "id": "J0GwzkKsdkcs5vt7tw9Ij",
              "key": "LoggedInNavbar",
              "properties": null
            },
            "properties": null
          },
          {
            "component": {
              "id": "EQbzUHM0RQafgw7sX73nxw",
              "key": "PitchPanel",
              "properties": null
            },
            "properties": [
              {
                "name": "json",
                "article": null,
                "book": null,
                "boolean": null,
                "dynamicList": null,
                "entity": null,
                "fixedList": null,
                "id": null,
                "int": null,
                "json": "{\"sourceId\":\"mFrJCxiHQESBl-vkUjMH2g\",\"viewMode\":\"GRID\",\"showBtn\":true }",
                "listCollection": null,
                "newsletter": null,
                "number": null,
                "onlineCourse": null,
                "originalContent": null,
                "person": null,
                "podcast": null,
                "poster": null,
                "string": null
              }
            ]
          },
          {
            "component": {
              "id": "WnQrbnTITU2VwR0hR3qZ8A",
              "key": "Footer",
              "properties": null
            },
            "properties": null
          }
        ]
      }
    }
  },
  "home-": {
    "urlRouteByAlias": {
      "hasErrors": false,
      "errors": null,
      "node": {
        "id": "pqANVoBqR7m42XtJ42DeVw",
        "panels": [
          {
            "component": {
              "id": "YX1l21aje0ia7Jtrelh5cw",
              "key": "TransparentNavbar",
              "properties": null
            },
            "properties": [
              {
                "name": "json",
                "article": null,
                "book": null,
                "boolean": null,
                "dynamicList": null,
                "entity": null,
                "fixedList": null,
                "id": null,
                "int": null,
                "json": "{\"hideNavigation\":\"true\"}",
                "listCollection": null,
                "newsletter": null,
                "number": null,
                "onlineCourse": null,
                "originalContent": null,
                "person": null,
                "podcast": null,
                "poster": null,
                "string": null
              }
            ],
            "id": "Fms4WBQAmUyYXymTQBh8nw"
          },
          {
            "component": {
              "id": "nArNF0KuShm3QhsiyYICWQ",
              "key": "SignupPage",
              "properties": null
            },
            "properties": [
              {
                "name": "fixedList",
                "article": null,
                "book": null,
                "boolean": null,
                "dynamicList": null,
                "entity": null,
                "fixedList": {
                  "id": "E59ZC9ZFQqmmvyKop_Ghlg"
                },
                "id": null,
                "int": null,
                "json": null,
                "listCollection": null,
                "newsletter": null,
                "number": null,
                "onlineCourse": null,
                "originalContent": null,
                "person": null,
                "podcast": null,
                "poster": null,
                "string": null
              },
              {
                "name": "listCollection",
                "article": null,
                "book": null,
                "boolean": null,
                "dynamicList": null,
                "entity": null,
                "fixedList": null,
                "id": null,
                "int": null,
                "json": null,
                "listCollection": {
                  "id": "TNmnUeHAekqD6NpaBpkTOA"
                },
                "newsletter": null,
                "number": null,
                "onlineCourse": null,
                "originalContent": null,
                "person": null,
                "podcast": null,
                "poster": null,
                "string": null
              }
            ],
            "id": "6N2huQzNi0yWbarJY9tQC12"
          },
          {
            "component": {
              "id": "WnQrbnTITU2VwR0hR3qZ8A",
              "key": "Footer",
              "properties": null
            },
            "properties": null,
            "id": "6N2huQzNi0yWbarJY9tQCw"
          }
        ]
      }
    }
  }
};
